<template>
  <div>
    <h1>Create a new  List</h1>
    <ChecklistCreateForm />
  </div>
</template>

<script>
import ChecklistCreateForm from '@/components/forms/checklist-create-form.vue'

export default {
  name: 'CreateChecklist',
  components: {
    ChecklistCreateForm
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
}
</script>
